import Model from "./Model";
import HoverMask from "./HoverMask";
import State from "./State";
import RGBA from "../Fonts/RGBA";
import colorSchemeRepository from "../Images/ColorSchemeRepository";
import UrlExecutor from "../Api/UrlExecutor";

export default class Search extends Model {
    constructor(width, height, data) {

        super(width, height, data);
        this.game = data.game;
        this.clearBeforePositioning = true;
        this.hoverMask = new HoverMask(this, true);
        this.state = new State();
    }

    draw(ctx) {
        const box = this.getButtonBox();

        let svgSize = 40;
        let svgOutputSize = 20;
        let iconScale = svgOutputSize / svgSize;

        this.circleSize = Math.PI * 2;
        ctx.beginPath();
        ctx.fillStyle = colorSchemeRepository.get('roomBackground');
        let start = Math.PI * 1.5 + this.circleSize / 2;
        ctx.arc(this.scale(box.x + box.width / 2), this.scale(box.y + box.height / 2), this.scale(box.width * 1.2), start, this.circleSize + start);
        ctx.fill();

        const path = new Path2D('M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z');
        ctx.save();
        ctx.fillStyle = new RGBA(255);
        ctx.translate(this.scale(box.x), this.scale(box.y));
        ctx.scale(this.zoom * iconScale, this.zoom * iconScale);
        ctx.fill(path, 'evenodd');
        ctx.restore();

        this.hoverMask.add('search', box.x - box.width / 2, box.y - box.height / 2, this.scale(box.width) * 2, this.scale(box.height) * 2)
            .click(() => {
                UrlExecutor.execute(this.game.searchUrl);
            });
    }

    garbageCollect() {
        super.garbageCollect();
        this.hoverMask.remove('search');
    }

    getButtonBox() {
        let box = {
            width: 25,
            height: 25,
            x : 10,
            y : 0
        };

        box.x = (this.width - box.width) / 2;
        box.y = (this.height - box.height) / 2;

        return box;
    }
}